/* ============================================
   CONTACTFORM.JSX - COMPONENT FILE
   📁 File location: src/components/ContactForm.jsx
   📝 Contact form with social links and image
   ============================================ */

import React, { useState } from 'react';
import '../../../../assets/css/Buyer/Home/homecontactUs.css';
import { FaArrowRight } from 'react-icons/fa';

/* ============================================
   CONTACT FORM COMPONENT
   ============================================ */
function ContactUs() {
  
  /* ========================================
     🎯 STATE - Form data management
     ======================================== */
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    location: '',
    message: '',
  });

  /* ========================================
     🎬 EVENT HANDLERS
     ======================================== */
  
  /* Handle input changes */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  /* Handle form submission */
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // ⚠ Add your form submission logic here
    // For example: API call, email service, etc.
    
    // Reset form after submission
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      location: '',
      message: '',
    });
    
    alert('Thank you! We will contact you soon.');
  };

  /* ========================================
     🎨 JSX RETURN - Component structure
     ======================================== */
  return (
    <section className="contact-section">
      <div className="contact-container">
        
        {/* ========================================
             LEFT SECTION - Info + Social + Image
             ======================================== */}
        <div className="contact-left">
          {/* Contact Us label */}
          <div className="contact-label">
            <span className="dot">●</span> CONTACT US
          </div>
          
          {/* Main heading */}
          <h2 className="contact-heading">
            Complete this form<br />
            to contact our team
          </h2>
          
          {/* Follow Us section */}
          <div className="follow-section">
            <p className="follow-label">FOLLOW US:</p>
            
            {/* Social icons */}
            <div className="social-icons">
              {/* TikTok */}
              <a 
                href="https://tiktok.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="TikTok"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              
              {/* Instagram */}
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              
              {/* Twitter */}
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Twitter"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* City image */}
          <div className="city-image">
            <img 
              src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop" 
              alt="Dubai Skyline"
            />
          </div>
        </div>

        {/* ========================================
             RIGHT SECTION - Contact Form
             ======================================== */}
        <div className="contact-right">
          <form onSubmit={handleSubmit} className="contact-form">
            
            {/* First Name & Last Name - 2 columns */}
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First Name*"
                  required
                  className="contactform-input"
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last Name*"
                  required
                  className="contactform-input"
                />
              </div>
            </div>

            {/* Phone Number */}
            <div className="form-group">
              <input
                type="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number*"
                required
                className="contactform-input"
              />
            </div>

              {/* Email Address */}
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address*"
                required
                className="contactform-input"
              />
            </div>

            {/* Location dropdown */}
            <div className="form-group">
              <select
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                className="contactform-input contactform-select"
              >
                <option value="">Location</option>
                <option value="karachi">Karachi</option>
                <option value="lahore">Lahore</option>
                <option value="islamabad">Islamabad</option>
                <option value="dubai">Dubai</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Message textarea */}
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                rows="6"
                className="contactform-input  contactform-textarea"
              ></textarea>
            </div>

            {/* Submit button  
            <button type="submit" className="submit-btn">
              Submit
            </button>*/}
           
          </form>
           <a href="#" className="explore-btn">
                <span>Submit</span>
            <div className="btn-icon">
              <FaArrowRight />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;